import React, { act } from "react";
import classes from "./Tab.module.css";
const Tab = ({ Tag = "button", label, children, active = false ,onClick=()=>{}}) => {
  return (
    <Tag className={`${classes.tab} ${active ? classes.active : ""}`} onClick={onClick}>
      {[

        active && <span className={classes.activeIndicator} />,
        label || children,
      ]}
    </Tag>
  );
};

export default Tab;
